import React, { Component } from "react";
import zapierLogo from "../../../../assets/images/zapier/zapier-logo.png";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";

type Props = {};

type State = {};

class ZapierConnect extends Component<Props, State> {
    render() {
        return (
            <div className="ZapierConnect">
                <OwAccordion
                    leftImage={zapierLogo}
                    leftImageHeight={30}
                    hideChevron={true}
                    rightElem={
                        <div className={"ms-auto"}>
                            <div>Please contact support to setup integration.</div>
                        </div>
                    }></OwAccordion>
            </div>
        );
    }
}

export default ZapierConnect;
